import { toast } from "react-hot-toast";
import { 
  staticProducts, 
  staticCategories, 
  staticTags, 
  staticUser,
  getProductById
} from "@/data/staticData";

/**
 * Generic API request handler - Returns static data
 * @param {string} endpoint - The API endpoint
 * @param {'get' | 'post' | 'put' | 'delete' | 'patch'} method - HTTP method
 * @param {Object} payload - Data to send in the request
 * @param {Object} options - Additional axios options (e.g., custom headers)
 * @returns {Promise<any>} - The API response data
 */

export const apiHandler = async (
  endpoint,
  method = "get",
  payload = {},
  options = {},
  headers = {}
) => {
  try {
    // Return static data based on endpoint
    const endpointLower = endpoint.toLowerCase();
    let responseData = { data: null, message: "Success" };
    
    // Auth endpoints
    if (endpointLower.includes("login") || endpointLower.includes("register")) {
      responseData = { 
        token: "mock-token-12345",
        user: staticUser,
        message: "Authentication successful"
      };
    } else if (endpointLower.includes("verify-otp")) {
      responseData = { 
        success: true,
        message: "OTP verified successfully"
      };
    } else if (endpointLower.includes("myprofile") || endpointLower.includes("user")) {
      responseData = { data: staticUser };
    }
    // Products endpoints
    else if (endpointLower.includes("products") || endpointLower.includes("product")) {
      responseData = { data: staticProducts };
    }
    // Categories endpoints
    else if (endpointLower.includes("categories") || endpointLower.includes("category")) {
      responseData = { data: staticCategories };
    }
    // Tags endpoints
    else if (endpointLower.includes("tags") || endpointLower.includes("tag")) {
      responseData = { data: staticTags };
    }
    
    console.log("Static API response for", endpoint, ":", responseData);
    return responseData;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Handles API errors and shows toast notifications
 * @param {Error} error - The error object
 */
export const handleApiError = (error) => {
  if (error.response) {
    console.log(error);
    const { data } = error.response;
    console.log(data);

    if (data.errors) {
      const errorMessages = Object.values(data.errors).flat();
      errorMessages.forEach((message) => {
        // toast.error(message);
      });
    } else if (data) {
      // toast.error(data[0]);
    } else {
      // toast.error("An error occurred. Please try again.");
    }
  } else {
    // toast.error(error.message || "Network error.");
  }
};
